import { fmtTL, fmtNum } from "../../lib/format";

// Hakediş hizmet / bölge özet satırı: düzeltme farkı hizmete yazılmışsa gösterilen toplam = hizmet tutarı + düzeltme (mor rozet); eşleşmeyen fark ayrı mor satır
export function SummaryRow({ s, priceKey, totalKey, testid }) {
  const corr = s.correction_total || 0;
  const shown = (s[totalKey] || 0) + corr;
  return (
    <tr className={`border-t border-slate-100 ${s.is_correction ? "bg-violet-50/60 text-violet-900 font-semibold" : ""}`} data-correction={s.is_correction ? "1" : undefined} data-testid={testid} data-folded={corr ? "1" : undefined}>
      <td className="px-4 py-2 text-sm">{s.service_name}
        {corr !== 0 && <span data-testid="summary-correction-badge" className={`ml-2 px-1.5 py-0.5 rounded bg-violet-100 text-[10px] font-semibold ${corr < 0 ? "text-red-700" : "text-violet-900"}`} title={`Bu hizmetin düzeltme farkı (${s.correction_count} kayıt) toplama dahil`}>düzeltme {corr > 0 ? "+" : ""}{fmtTL(corr)}</span>}
      </td>
      <td className="numeric-cell px-4 py-2 text-sm">{fmtNum(s.quantity)}</td>
      <td className="px-4 py-2 text-xs text-center">{s.unit}</td>
      <td className="numeric-cell px-4 py-2 text-sm">{fmtTL(s[priceKey])}</td>
      <td className="numeric-cell px-4 py-2 text-sm font-semibold" title={corr ? `${fmtTL(s[totalKey])} + düzeltme ${fmtTL(corr)}` : undefined}>{fmtTL(shown)}</td>
    </tr>
  );
}
